import { IconButton, makeStyles, styled, Tooltip } from "@material-ui/core";
import { div, FormHyperlink, FormInput, span } from "lqx-react";
import React, { useState } from "react";

export const CopyRow = ({ label, value, currency = false, number = false, date = false, hyperlinkHref = '' }) => {
    const defaultContent = '-';
    const classes = useCopyRowStyles();
    const [copyButtonStyle, setCopyButtonStyle] = useState({ display: 'none' });
    const [copyButtonIcon, setCopyButtonIcon] = useState('copy-button fa fa-copy');
    const [copyButtonLabel, setCopyButtonLabel] = useState('Copy');

    const CopyLabel = div({
        display: 'inline-flex',
        '&:hover .copy-button': {
            display: 'block !important'
        },
    });

    const CopyButton = styled(IconButton)({
        marginTop: '-10px',
        marginRight: '-30px',
        marginLeft: '-20px',
    });

    const CopyTooltip = span({
        fontSize: '12px',
    });

    const copyToClipBoard = async copyMe => {
        try {
            await navigator.clipboard.writeText(copyMe);
            setCopyButtonIcon('copy-button fa fa-check');
            setCopyButtonLabel('Copied');
        } catch (err) { }
    };

    return (
        <>
            <CopyLabel
                onMouseEnter={e => {
                    setCopyButtonIcon('copy-button fa fa-copy');
                    setCopyButtonLabel('Copy');
                }}>


                <div style={{ width: '100%', height: '33px' }}>
                    {
                        hyperlinkHref && value && value != defaultContent
                            ?
                            <FormHyperlink label={label} className={classes.textAlignRightLink} href={`${hyperlinkHref}`} linkLabel={value.toString()} />
                            :
                            <FormInput label={label} className={classes.textAlignRight} currency={currency} number={number} date={date} value={value} />
                    }
                </div>
                {value != defaultContent && value != '0' && value &&
                    <Tooltip title={<CopyTooltip>{copyButtonLabel} {label}</CopyTooltip>}>
                        <CopyButton style={copyButtonStyle} className={copyButtonIcon} onClick={() => copyToClipBoard(value)} />
                    </Tooltip>
                }
            </CopyLabel>
        </>
    )
}

const useCopyRowStyles = makeStyles({
    textAlignRight: {
        textAlign: 'right',
        paddingRight: '20px',
    },
    textAlignRightLink: {
        textAlign: 'right',
        padding: '4px 20px 3px 3px',
        fontSize: '14px',
        marginBottom: '3px'
    }
})
